import equalByNameAndPaymentParamId from '../../utils/equalByNameAndPaymentParamId';
import dateConverter from '../../../../utils/converters/date.converter';
import { i18n } from "../../../vue-i18n";

export default class ChangePaymentFirstDate {
  constructor(paymentParametersId, newFirstPaymentDate, isLastPeriodDate) {
    this.commandName = "ChangeFirstPaymentDate";

    this.paymentParametersId = paymentParametersId;
    this.newFirstPaymentDate = newFirstPaymentDate;
    this.isLastPeriodDate = isLastPeriodDate;

    const convertedDate = dateConverter.convertToDate(newFirstPaymentDate);
    this.description =
      `${i18n.t('CONTENT.events.new_first_payment_date')}: ${i18n.d(convertedDate)}`;
  }

  // Use this method to push this command to the server
  serialize() {
    return {
      commandName: this.commandName,
      serialisedCommand: JSON.stringify({
        PaymentParametersId: this.paymentParametersId,
        NewFirstPaymentDate: this.newFirstPaymentDate,
        IsLastPeriodDate: this.isLastPeriodDate,
      })
    }
  }

  equal = (other) => equalByNameAndPaymentParamId(this, other);
}
